import React from 'react';
import { initialsOf } from './utils/text';

// Shared speaker line: avatar (with the country flag) + name + headline + organization,
// linking to the speaker's profile. Single source of truth for the event modal and the
// featured card, both fed by the presenter's speaker shape. `size` tunes avatar/name
// (sm | md | lg).
const SpeakerRow = ({ speaker, size = 'md' }) => {
    if (!speaker) return null;

    return (
        <a href={speaker.profile_url} className={`ev-speaker ev-speaker--${size}`}>
            <span className="ev-speaker__avatar">
                {speaker.headshot_url
                    ? <img className="ev-speaker__photo" src={speaker.headshot_url} alt={speaker.name} />
                    : <span className="ev-speaker__photo ev-speaker__initials">{initialsOf(speaker.name)}</span>}
                {speaker.flag_url && (
                    <img
                        className="ev-speaker__flag"
                        src={speaker.flag_url}
                        alt=""
                        aria-hidden="true"
                        title={speaker.country}
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                )}
            </span>
            <span className="ev-speaker__info">
                <strong className="ev-speaker__name">{speaker.name}</strong>
                {speaker.headline && <span className="ev-speaker__meta">{speaker.headline}</span>}
                {speaker.organization && <span className="ev-speaker__meta">{speaker.organization}</span>}
            </span>
        </a>
    );
};

export default SpeakerRow;
